export const address = {
  para: {
    or: 'or',
  },
  label: 'This address is',
  idk: "I don't know",
  idkCapitalized: 'I Don\'t Know',
  spinner: 'Verifying your address',
  physicalLocationRequired:
    'Provide physical location data with street address, base, post, embassy, unit, and country location or home port/fleet headquarter.',
  apoFpoRequired: 'Provide APO/FPO address.',
  confirmation: 'Are you sure you would like to change your answer? This will remove any data currently entered.',
  militaryAddress: {
    meResidence: 'Did you have an APO/FPO address while at this location?',
    meEmployment: 'Do you or did you have an APO/FPO address while at this location?',
    spouse: 'Does the person have an APO/FPO address?',
    relative: 'Does this relative have an APO/FPO address?',
    foreignNational: 'Does this person have an APO/FPO address?',
    supervisor: 'Did/does your supervisor have an APO/FPO address while at this location?',
    residenceVerifier: 'Does the person who knew you have an APO/FPO address?',
  },
  options: {
    us: {
      label: 'In the U.S.',
    },
    apoFpo: {
      label: 'APO/FPO',
    },
    international: {
      label: 'Outside the U.S.',
    },
  },
  us: {
    street: {
      label: 'Street address',
    },
    street2: {
      label: 'Apt, suite, building, floor, etc.',
      optional: '(Optional)',
    },
    city: {
      label: 'City',
    },
    state: {
      label: 'State',
    },
    county: {
      label: 'County',
    },
    zipcode: {
      label: 'ZIP Code',
    },
  },
  physical: {
    street: {
      label: 'Street Address/Unit/Duty Location',
    },
    city: {
      label: 'City or Post Name',
    },
  },
  international: {
    street: {
      label: 'Address',
    },
    city: {
      label: 'City',
    },
    country: {
      label: 'Country',
    },
    zipcode: {
      label: 'ZIP Code',
    },
  },
  apoFpo: {
    select: {
      label: 'Select APO or FPO',
    },
    street: {
      label: 'Address',
    },
    city: {
      label: 'City',
    },
    state: {
      label: 'State',
    },
    zipcode: {
      label: 'ZIP Code',
    },
    apoFpo: {
      label: 'APO/FPO State Code',
    },
    apoFpoType: {
      apo: {
        label: 'APO',
      },
      fpo: {
        label: 'FPO',
      },
      apoFpo: {
        label: 'APO/FPO',
      },
    },
  },
  addressBook: {
    reuse: 'Choose a previously used address',
  },
  pvq: {
    domesticTitle: 'What is the address?',
    foreignTitle: 'Where is the residence located?',
    physicalAddress: 'Please provide physical address (not mailing address)',
    label: 'Do you currently live in the U.S.?',
    para: {
      or: 'or',
    },
    idkCapitalized: 'I Don\'t Know',
    installation: {
      foreign: {
        title: 'What is the name of this U.S. military installation or U.S. diplomatic facility?',
      },
      name: {
        title: 'What is the name of this U.S. military installation?',
      },
      branch: {
        label: 'Is this a U.S. military installation?',
      },
      foreignBranch: {
        label: 'Is this a U.S. military installation or U.S. diplomatic facility?',
      },
      nameNA: {
        label: 'I Don\'t Know',
        or: 'or',
      },
      nameExplanation: {
        label: 'Please Explain',
      },
      zipcode: {
        label: 'What is the APO/FPO/DPO ZIP Code?',
      },
    },
    us: {
      street: {
        label: 'Street (include Apt #, Unit #, or Suite #, if applicable)',
      },
      street2: {
        label: 'Apt, suite, building, floor, etc.',
        optional: '(Optional)',
      },
      city: {
        label: 'City',
      },
      state: {
        label: 'State or Territory',
      },
      county: {
        label: 'County',
        financialLabel: 'County Or County Equivalent',
      },
      zipcode: {
        label: 'ZIP Code',
      },
    },
    physical: {
      street: {
        label: 'Street Address/Unit/Duty Location',
      },
      city: {
        label: 'City or Post Name',
      },
    },
    international: {
      street: {
        label: 'Please provide physical address (not mailing address).',
      },
      city: {
        label: 'City',
      },
      country: {
        label: 'Country',
      },
      zipcode: {
        label: 'ZIP Code',
      },
    },
  },
};
